import { GetServerSideProps } from 'next';
import Page, { getServerSideProps as getProps } from '@pages/explore/toys/index';
export const getServerSideProps: GetServerSideProps = getProps;
export default Page;